import { useContext } from "react";
import TokenContext from "../tokenContext";
/**
 * Wraps our constructed context object to ensure we're able query it within the component hierachy
 * @returns custom hook for checking for the presence of a auth token
 */
export const useTokenContext = () => {
  const context = useContext(TokenContext);

  if (context === undefined) {
    throw new Error("useTokenContext can only be used inside TokenProvider");
  }

  return context;
};
